const getSiteIdToSwitchTemplate = (rootState) => rootState.sites.siteIdToSwitchTemplate;

export default getSiteIdToSwitchTemplate;
